"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var jquery_1 = __importDefault(require("jquery"));
function createTaskChooser(id) {
    var chooserElement = jquery_1["default"]('#' + id + '-chooser');
    var taskName = chooserElement.find('.name');
    var input = jquery_1["default"]('#' + id);
    var editAction = chooserElement.find('.action-edit');
    jquery_1["default"]('.action-choose', chooserElement).on('click', function () {
        // eslint-disable-next-line no-undef, new-cap
        ModalWorkflow({
            url: chooserElement.data('chooserUrl'),
            // eslint-disable-next-line no-undef
            onload: TASK_CHOOSER_MODAL_ONLOAD_HANDLERS,
            responses: {
                taskChosen: function (data) {
                    input.val(data.id);
                    taskName.text(data.name);
                    chooserElement.removeClass('blank');
                    editAction.attr('href', data.edit_url);
                }
            }
        });
    });
}
window.createTaskChooser = createTaskChooser;
